import React, { Component } from 'react'
import { Paper, TextField, Typography, Link, CircularProgress } from '@material-ui/core'
import { FlatButton } from 'shared/mui-styles';

const classes = {
    errorCard: {
        width: '450px',
        overflow: 'hidden',
        height: 56,
    },
    card: {
        width: '450px',
        padding: '2rem 3rem 3rem',
    },
    fullWidth: {
        width: '100%',
    },
    headerText: {
        fontWeight: '400',
    }
}

class LoginComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            password: '',
        }
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value })
    }

    handleSubmit = (e) => {
        const { email, password } = this.state;
        e.preventDefault()
        this.props.userLogin(email, password)
    }

    registerClick = (event) => {
        const { history } = this.props;
        event.preventDefault();
        history.push('/user/register')
    }

    render() {
        const { email, password } = this.state;
        const { error, isFetching } = this.props;

        return (
            <div className="body-center vertical">
                <div style={{ marginTop: -55 }}>
                    <div style={{ height: 72, paddingBottom: 15 }}>
                        {isFetching && (
                            <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <CircularProgress />
                            </div>
                        )}
                        {error && (
                            <Paper elevation={1} style={classes.errorCard}>
                                <div style={{ height: '100%', display: 'flex ' }}>
                                    <div className="error-line" />
                                    <div style={{ display: 'flex', alignItems: 'center', padding: '1rem' }}>
                                        <Typography variant="button" style={{ marginRight: 6 }}>Error:</Typography>
                                        <Typography variant="body2">{error}</Typography>
                                    </div>
                                </div>
                            </Paper>
                        )}
                    </div>
                    <Paper elevation={1} style={classes.card}>
                        <div style={{ marginBottom: '1.2rem', textAlign: 'center' }}>
                            <Typography variant="h6" style={classes.headerText}>
                                Login to Download Data
                            </Typography>
                        </div>
                        <form onSubmit={this.handleSubmit}>
                            <div className="row">
                                <div className="col">
                                    <TextField
                                        name="email"
                                        label="Email"
                                        style={classes.fullWidth}
                                        value={email}
                                        onChange={this.handleChange}
                                        autoComplete="email"
                                        margin="normal"
                                        variant="outlined"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <TextField
                                        name="password"
                                        label="Password"
                                        style={classes.fullWidth}
                                        value={password}
                                        onChange={this.handleChange}
                                        type="password"
                                        autoComplete="current-password"
                                        margin="normal"
                                        variant="outlined"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col text-center">
                                    <FlatButton
                                        style={{ margin: '16px 0 42px' }}
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        size="large"
                                        fullWidth
                                    >
                                        Login
                                    </FlatButton>
                                </div>
                            </div>
                        </form>
                        <div className="row">
                            <div className="col text-center">
                                <Typography variant="body2">
                                    Don't have an account? <Link href="#" onClick={this.registerClick}>Register New User</Link>
                                </Typography>
                            </div>
                        </div>
                    </Paper>
                </div>
            </div>
        )
    }
}

export default LoginComponent